import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState, type FormEvent } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";

export const Route = createFileRoute("/reset-password")({
  ssr: false,
  head: () => ({ meta: [{ title: "Passwort zurücksetzen" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (pwd.length < 8) return setError("Mindestens 8 Zeichen.");
    if (pwd !== pwd2) return setError("Passwörter stimmen nicht überein.");
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password: pwd });
    setBusy(false);
    if (error) return setError(error.message);
    setDone(true);
    setTimeout(() => navigate({ to: "/app", replace: true }), 1200);
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-12">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Neues Passwort setzen</CardTitle>
          <CardDescription>Wählen Sie ein neues, sicheres Passwort.</CardDescription>
        </CardHeader>
        <CardContent>
          {done ? (
            <Alert><AlertDescription>Passwort aktualisiert. Weiterleitung …</AlertDescription></Alert>
          ) : (
            <form onSubmit={onSubmit} className="space-y-4">
              {error && <Alert variant="destructive"><AlertDescription>{error}</AlertDescription></Alert>}
              <div className="space-y-2">
                <Label htmlFor="p1">Neues Passwort</Label>
                <Input id="p1" type="password" minLength={8} required value={pwd} onChange={(e) => setPwd(e.target.value)} />
              </div>
              <div className="space-y-2">
                <Label htmlFor="p2">Passwort wiederholen</Label>
                <Input id="p2" type="password" minLength={8} required value={pwd2} onChange={(e) => setPwd2(e.target.value)} />
              </div>
              <Button type="submit" className="w-full" disabled={busy}>{busy ? "…" : "Passwort speichern"}</Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
